import { NgClass } from '@angular/common';
import { Component, computed, input, Signal, ChangeDetectionStrategy } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { MatIcon } from '@angular/material/icon';
import { SortUtil } from '@iot-platform/iot-platform-utils';
import { BusinessProfile, UserAccount } from '@iot-platform/models/common';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  imports: [FlexLayoutModule, MatIcon, NgClass, TranslatePipe],
  selector: 'iot-platform-ui-user-related-business-profiles',
  changeDetection: ChangeDetectionStrategy.Eager,
  templateUrl: './user-related-business-profiles.component.html'
})
export class UserRelatedBusinessProfilesComponent {
  currentUser = input<UserAccount>();

  bPSortedByEntityLevel: Signal<BusinessProfile[]> = computed(() => {
    const user = this.currentUser();
    const sortedBPs = Object.assign([], user?.businessProfiles);
    sortedBPs.sort(SortUtil.sortByProperty('level'));
    return sortedBPs;
  });
}
